import { roomViewTypesConstants } from "../../../../constants/Network/RoomAndRates/roomViewTypes.constants";

const initialState = {
    fetching : false,
    roomViewTypes : [],
    error : {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case roomViewTypesConstants.ROOM_VIEW_TYPE_PENDING:
            return {
                ...state,
                fetching: true,
            };
        case roomViewTypesConstants.ROOM_VIEW_TYPE_FULFILLED:
            return {
                ...state,
                fetching: false,
                roomViewTypes: action.payload
            };
        case roomViewTypesConstants.ROOM_VIEW_TYPE_REJECTED:
            return {
                ...state,
                fetching: false,
                error: action.payload,
            };
        default:
            return state
    }
}
